<template>
    <v-container  fluid fill-height class="email-sent mt-4">
        <v-layout flex align-center justify-center>
            <div class="text-xs-center mt-2 ">
                <qr-code :size="250" :text="qrcode_uri"></qr-code>

                <div style="width: 250px;text-align: left" class="mt-2">
                    {{ qrcode_uri }}
                    <br>
                    <!--<input type="hidden" id="uri-link" :value="qrcode_uri">-->
                    <div v-if="!qrcode_uriMulti" style="text-align: center;">

                        <!--<v-btn color="success" small  class="font-weight-bold mt-1" @click.stop.prevent="copyLinkUri"><v-icon left>mdi-clipboard-text</v-icon>คัดลอกลิงค์</v-btn>-->

                        <button class="font-weight-bold mt-1 v-btn v-btn--small theme--light success" v-clipboard="qrcode_uri"
                             v-clipboard:success="clipboardSuccessHandler"
                             v-clipboard:error="clipboardErrorHandler">
                            <v-icon left class="white--text">mdi-clipboard-text</v-icon>
                            คัดลอกลิงค์
                        </button>
                    </div>
                </div>

                <h2 class="font-weight-bold mt-3">กรุณาส่อง QR Code<br>เพื่อทำการประเมิน</h2>

                <v-btn v-if="!qrcode_uriMulti" color="info" large dark block class="font-weight-bold mt-4" @click="back_to_emp()">กลับไปหน้าค้นหาพนักงาน</v-btn>

            </div>
        </v-layout>
    </v-container>
</template>

<script>
    import Vue from 'vue'
    import VueQRCodeComponent from 'vue-qrcode-component'
    Vue.component('qr-code', VueQRCodeComponent)

    export default {
        name: "EvaQrcode",
        props:{
            qrcode_uri:String,
            qrcode_uriMulti: Boolean
        },
        methods:{
            back_to_emp(){
                this.$emit('back_to_emp')
            },
            // copyLinkUri () {
            //     let cc = document.querySelector('#uri-link')
            //     cc.setAttribute('type', 'text')
            //     cc.select()
            //
            //     try {
            //         let successful = document.execCommand('copy');
            //         let msg = successful ? 'เรียบร้อยแล้ว!' : 'ไม่ได้';
            //         alert('คัดลอกลิงค์ ' + msg);
            //     } catch (err) {
            //         alert('Oops, unable to copy');
            //     }
            //     //unselect the range
            //     cc.setAttribute('type', 'hidden')
            //     window.getSelection().removeAllRanges()
            // },
            clipboardSuccessHandler () {
                alert('คัดลอกลิงค์สำเร็จ!')
            },
            clipboardErrorHandler () {
                alert('ไม่สามารถคัดลอกลิงค์ได้ กรุณาคัดลอกจากตัวอักษรแทน')
            }
        }
    }
</script>

<style scoped>

</style>